import { CATEGORY_ORDER } from '@/widgets/pricing/pricingCards/lib/constants';
import { ActionButtonTitle } from '@/widgets/pricing/pricingCards/lib/enums';

import { PaymentInterval, Plan, PlanCategory } from '@/shared/types/Billing';
import { User } from '@/shared/types/User';

type GetButtonTitle = {
  hasCanceledSubscription: boolean;
  hasExpiredSubscription: boolean;
  hasPausedSubscription: boolean;
  hasSubscriptionCancelAtPeriodEnd: boolean;
  hasTrialingEnterprisePlan: boolean;
  hasTrialPlan: boolean;
  isPlanActive: boolean;
  isPriceActive: boolean;
  plan: Plan;
  plans?: Plan[];
  subscription?: User['subscription'];
};

export const getButtonTitle = ({
  hasCanceledSubscription,
  hasExpiredSubscription,
  hasPausedSubscription,
  hasSubscriptionCancelAtPeriodEnd,
  hasTrialingEnterprisePlan,
  hasTrialPlan,
  isPlanActive,
  isPriceActive,
  plan,
  plans,
  subscription,
}: GetButtonTitle) => {
  const planCategory = plan.category;
  if (hasTrialPlan || !subscription || hasCanceledSubscription || hasExpiredSubscription) {
    return ActionButtonTitle.GetStarted;
  }

  if (hasTrialingEnterprisePlan) {
    return ActionButtonTitle.Upgrade;
  }

  if (isPlanActive && !isPriceActive) {
    const isYearPlan = subscription.plan.interval === PaymentInterval.Year;
    return isYearPlan ? ActionButtonTitle.Downgrade : ActionButtonTitle.SwitchToAnnual;
  }

  if (isPlanActive && (hasPausedSubscription || hasSubscriptionCancelAtPeriodEnd || hasCanceledSubscription)) {
    return ActionButtonTitle.Renew;
  }

  if (planCategory === PlanCategory.Enterprise) {
    return ActionButtonTitle.GetStarted;
  }

  const currentUserPlan = plans?.find((planData) => planData.id === subscription.plan.product_id);
  const currentUserPlanOrder = currentUserPlan ? CATEGORY_ORDER[currentUserPlan.category] : 0;
  const targetPlanOrder = CATEGORY_ORDER[planCategory];

  const isLowerCategory = targetPlanOrder < currentUserPlanOrder;
  const isSameCategory = targetPlanOrder === currentUserPlanOrder;
  const isLowerBundlePosition =
    currentUserPlan && plan.metadata.bundle_position < currentUserPlan.metadata.bundle_position;

  const isDowngrade = isLowerCategory || (isSameCategory && isLowerBundlePosition);

  if (isDowngrade) {
    return ActionButtonTitle.Downgrade;
  }

  return ActionButtonTitle.Upgrade;
};
